function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.71468 3.14336C8.80449 2.86697 9.19551 2.86697 9.28532 3.14336L10.1304 5.74418C10.358 6.44461 11.0107 6.91885 11.7472 6.91885H14.4818C14.7724 6.91885 14.8933 7.29073 14.6582 7.46155L12.4458 9.06894C11.8499 9.50184 11.6006 10.2692 11.8282 10.9696L12.6733 13.5704C12.7631 13.8468 12.4467 14.0766 12.2116 13.9058L9.99924 12.2984C9.40341 11.8655 8.59659 11.8655 8.00077 12.2984L5.78838 13.9058C5.55327 14.0766 5.23692 13.8468 5.32673 13.5704L6.17178 10.9696C6.39937 10.2692 6.15005 9.50184 5.55422 9.06894L3.34184 7.46155C3.10672 7.29073 3.22756 6.91885 3.51818 6.91885H6.25283C6.98932 6.91885 7.64204 6.44461 7.86963 5.74418L8.71468 3.14336Z",
  stroke: "currentColor",
  strokeWidth: 1.4
});

function SvgStaricon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaricon);
export default __webpack_public_path__ + "static/media/star.icon.6cc1e532.svg";
export { ForwardRef as ReactComponent };